import Vue       from 'vue'
import ElementUI from 'element-ui'
import App       from './App'
import store     from '@store'
import router    from '@router'
import th  from 'element-ui/lib/locale/lang/th'
import en from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import '@styles/main.css'
import 'animate.css'
import VueTheMask from 'vue-the-mask'
import * as LottiePlayer from "@lottiefiles/lottie-player";
import i18n from '@/helper/i18n'
import VueGtag from 'vue-gtag'
import VueQrcode from '@chenfengyuan/vue-qrcode'

Vue.component(VueQrcode.name, VueQrcode);
Vue.use(VueTheMask)
Vue.use(ElementUI, {locale: i18n.availableLocales[0]=='th'?th:en }, LottiePlayer)
Vue.config.productionTip = false
Vue.config.devtools = (process.env.NODE_ENV !== 'production') ? true : false

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_MEASUREMENT_ID }
})

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
